import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WelcomePanel = ({ member, onCheckIn }) => {
  const [showQR, setShowQR] = useState(false);

  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  const getDaysUntilRenewal = () => {
    const renewalDate = new Date(member.membershipExpiry);
    const today = new Date();
    const diffTime = renewalDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysLeft = getDaysUntilRenewal();

  return (
    <div className="card">
      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
        <div className="flex-shrink-0">
          <div className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 rounded-full overflow-hidden border-4 border-primary/20">
            <Image
              src={member?.photo}
              alt={member?.photoAlt}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-4">
            <div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-2">
                {getGreeting()}, {member?.firstName}!
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                Ready to crush your fitness goals today?
              </p>
            </div>

            <Button
              variant="default"
              iconName="QrCode"
              iconPosition="left"
              onClick={() => setShowQR(!showQR)}
              className="w-full md:w-auto"
            >
              {showQR ? 'Hide QR' : 'Check In'}
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
            <div className="flex items-center gap-3 p-4 rounded-lg bg-muted">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon name="CreditCard" size={20} color="var(--color-primary)" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Membership</p>
                <p className="text-sm font-medium text-foreground">{member?.membershipType}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 rounded-lg bg-muted">
              <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center">
                <Icon name="Calendar" size={20} color="var(--color-success)" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Member Since</p>
                <p className="text-sm font-medium text-foreground">{member?.memberSince}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 rounded-lg bg-muted md:col-span-2 lg:col-span-1">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                daysLeft <= 7 ? 'bg-warning/10' : 'bg-accent/10'
              }`}>
                <Icon 
                  name="Clock" 
                  size={20} 
                  color={daysLeft <= 7 ? 'var(--color-warning)' : 'var(--color-accent)'} 
                />
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Renewal</p>
                <p className="text-sm font-medium text-foreground">
                  {daysLeft} days left
                </p>
              </div>
            </div>
          </div>

          {showQR && (
            <div className="flex flex-col items-center gap-4 p-6 rounded-lg bg-background border border-border">
              <div className="w-48 h-48 bg-white p-4 rounded-lg">
                <Image
                  src={member?.qrCode}
                  alt={member?.qrCodeAlt}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="text-center">
                <p className="text-sm font-medium text-foreground mb-1">
                  Member ID: {member?.memberId}
                </p>
                <p className="text-xs text-muted-foreground">
                  Scan at front desk to check in
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomePanel;